(() => {
  // TW — Unified Builder (Model D1)
  // Purpose: Construct and submit a Shopify cart payload from window.TWBuilder state.

  window.TWBuilder = window.TWBuilder || {};
  const TW = window.TWBuilder;

  if (!Array.isArray(TW.selectedScents)) TW.selectedScents = [];
  if (typeof TW.hasSelectedJourney !== "boolean") TW.hasSelectedJourney = false;
  if (typeof TW.requireJourney !== "function") {
    TW.requireJourney = function () {
      return !!TW.hasSelectedJourney;
    };
  }

  function getOrCreateBundleId() {
    if (TW._bundleId && typeof TW._bundleId === "string") return TW._bundleId;
    TW._bundleId = `tw_${Date.now().toString(36)}_${Math.random().toString(16).slice(2)}`;
    return TW._bundleId;
  }

  function toInt(val) {
    const n = parseInt(String(val || "0"), 10);
    return Number.isFinite(n) ? n : 0;
  }

  TW.validateSelections = function validateSelections() {
    if (!TW.selectedJourney || !toInt(TW.selectedJourney.variant_id)) {
      return { ok: false, reason: "No journey selected (missing selectedJourney.variant_id)." };
    }

    const limit = toInt(TW.selectedJourney.item_count);
    if (limit <= 0) {
      return { ok: false, reason: "Selected journey has invalid item_count." };
    }

    if (!Array.isArray(TW.selectedScents)) {
      return { ok: false, reason: "selectedScents is not an array." };
    }

    if (TW.selectedScents.length !== limit) {
      return {
        ok: false,
        reason: `Must select exactly ${limit} scents (currently ${TW.selectedScents.length}).`
      };
    }

    for (const s of TW.selectedScents) {
      if (!s || typeof s !== "object") {
        return { ok: false, reason: "selectedScents contains invalid entries." };
      }
      if (!s.handle) {
        return { ok: false, reason: "A selected scent is missing handle." };
      }
      if (!s.title) {
        return { ok: false, reason: "A selected scent is missing title." };
      }
      if (!toInt(s.product_id)) {
        return { ok: false, reason: "A selected scent is missing product_id." };
      }
      if (!toInt(s.inv_variant_id)) {
        return { ok: false, reason: `Scent "${s.title}" is missing inv_variant_id. Check inventory_variant_id metafield.` };
      }
    }

    return { ok: true, reason: "" };
  };

  TW.buildCartPayload = function buildCartPayload() {
    const validation = TW.validateSelections();
    const bundleId = getOrCreateBundleId();

    const journey = TW.selectedJourney || {};
    const journeyVariantId = toInt(journey.variant_id);
    const journeySize = toInt(journey.item_count);

    // Parent bundle line — priced listing variant (LOCKED: _tw_role = "listing")
    const parentItem = {
      id: journeyVariantId,
      quantity: 1,
      properties: {
        _tw_role: "listing",
        _tw_bundle_id: bundleId,
        _tw_journey_title: journey.title || "",
        _tw_journey_size: String(journeySize)
      }
    };

    // Component lines — resolved to -INV variant IDs
    const componentItems = (TW.selectedScents || []).map((s) => ({
      id: toInt(s.inv_variant_id),
      quantity: 1,
      properties: {
        _tw_role: "component",
        _tw_bundle_id: bundleId,
        _tw_scent_handle: s.handle,
        _tw_scent_title: s.title,
        _tw_scent_product_id: String(toInt(s.product_id))
      }
    }));

    return {
      ok: validation.ok,
      reason: validation.reason,
      bundle_id: bundleId,
      items: [parentItem, ...componentItems]
    };
  };

  // Submit payload to Shopify cart
  TW.addToCart = async function addToCart() {
    const payload = TW.buildCartPayload();

    if (!payload.ok) {
      console.warn("[TWBuilder] addToCart blocked:", payload.reason);
      return { ok: false, reason: payload.reason };
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: payload.items })
      });

      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        const reason = err.description || err.message || `HTTP ${response.status}`;
        console.error("[TWBuilder] /cart/add.js error:", reason);
        return { ok: false, reason };
      }

// GA4 Add to Cart event
      if (typeof gtag === 'function') {
        const priceRaw = parseFloat(((TW.selectedJourney && TW.selectedJourney.price) || '0').replace(/[^0-9.]/g, ''));
        gtag('event', 'add_to_cart', {
          currency: 'USD',
          value: priceRaw,
          items: (TW.selectedScents || []).map((s, i) => ({
            item_id: s.handle,
            item_name: s.title,
            index: i,
            quantity: 1
          }))
        });
      }

      // Reset bundle session on successful add
      TW._bundleId = null;

      return { ok: true };

    } catch (err) {
      console.error("[TWBuilder] addToCart fetch error:", err);
      return { ok: false, reason: err.message || "Network error" };
    }
  };

  TW.debugCartPayload = function debugCartPayload() {
    const payload = TW.buildCartPayload();
    console.log("[TWBuilder] cart payload:", payload);
    return payload;
  };

  document.addEventListener("tw:journey:selected", (e) => {
    if (e && e.detail) {
      TW.selectedJourney = e.detail;
      TW.hasSelectedJourney = true;
      TW._bundleId = null;
      console.log("[TWBuilder] journey updated from event:", TW.selectedJourney);
    }
  });
})();